import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5df84b8a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "report-history-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Page"], null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode($setup["NavigationBar"], { title: "신고내역" }),
        _createVNode($setup["DurationSelector"], {
          defaultFromDate: $setup.DEFAULT_FROM_DATE,
          defaultToDate: $setup.DEFAULT_TO_DATE,
          onOnSelectFromDate: _cache[0] || (_cache[0] = ($event: any) => ($setup.handleSelectFromDate($event.fromDate, $event.toDate))),
          onOnSelectToDate: _cache[1] || (_cache[1] = ($event: any) => ($setup.handleSelectToDate($event.fromDate, $event.toDate)))
        }, null, 8 /* PROPS */, ["defaultFromDate", "defaultToDate"]),
        _createVNode($setup["ReportHistoryList"], {
          class: "report-history-list",
          ref: "reportHistoryList",
          reportHistories: $setup.reportHistories
        }, null, 8 /* PROPS */, ["reportHistories"])
      ]),
      ($setup.reportHistoryList?.$el)
        ? (_openBlock(), _createBlock($setup["ScrollTopControl"], {
            key: 0,
            container: $setup.reportHistoryList.$el
          }, null, 8 /* PROPS */, ["container"]))
        : _createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }))
}